import { render, staticRenderFns } from "./BanAlert.vue?vue&type=template&id=008fff03&"
import script from "./BanAlert.vue?vue&type=script&lang=js&"
export * from "./BanAlert.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/atlassian/pipelines/agent/build/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('008fff03')) {
      api.createRecord('008fff03', component.options)
    } else {
      api.reload('008fff03', component.options)
    }
    module.hot.accept("./BanAlert.vue?vue&type=template&id=008fff03&", function () {
      api.rerender('008fff03', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/Profile/BanAlert.vue"
export default component.exports